<template>
  <div class="pages" v-loading="listLoading">
    <div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
      <Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
      <Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
      <Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
      <Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
      <Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
      <Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
      <File v-if='item.Property.Control=="File"' :data-val="item"></File>
      <Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
      <Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
      <Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
      <Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
    </div>


    <Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
            type="primary"> 提交
    </Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Dates from '../components/Date.vue';
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import Choose from "../components/Choose.vue";
import wx from "weixin-js-sdk";
import stringUtils from "../assets/js/stringUtil.js";
import { initWxConfig } from "../api/jssdk.js";
import { getTemplateInfo, submitProcess } from "@/api/approval";
import {getAgentInfo, getRelation, getUserInfo} from "@/api/employee"
import { getDepartmentInfo ,getDepartmentRelationByName } from "@/api/department";

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
  components: {
    Contact,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
    Dates
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      formLoading: false,
      listLoading: false,
      isDisabled: false,
      executiveDirector: []
    };
  },
  created() {
    this.logInfo = this.getLoginUserInfo();
    initWxConfig(this);
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.getTemplate();
    stringUtils.setAddIsShow(false);
  },
  methods: {
    clickChoose: async function (dataVal, name) {
      var that = this;
      window.wx.invoke(
          "selectEnterpriseContact",
          {
            fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
            mode: "single", // 必填，选择模式，single表示单选，multi表示多选
            type: ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
            selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          },
          async function (res) {
            if (res.err_msg === "selectEnterpriseContact:ok") {
              if (typeof res.result == "string") {
                res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
              }
              // 已选的部门列表
              var depart = res.result.departmentList[0];
              dataVal.Values = [];
              dataVal.Values.push([depart.id, depart.name]);
              dataVal.Value = depart.name;
            }
          }
      );
    },
    tableOperation (val, type, datas) {
      if (type === "床" || type === "家电" || type === "卫生间" || type === "厨房"){
        this.templateData.TemplateContent.Controls.forEach(col => {
          if (col.Property.Title[0].Text === "配套设施"){
            let showStr = null;
            let children = col.Config.Table.Children;
            if (!Array.isArray(val)){
              children.forEach(child => {
                if (child.Property.Title[0].Text === type){
                  let options = child.Config.Selector.Options;
                  options.forEach(option => {
                    if (option.Key === val){
                      showStr = option.Value[0].Text;
                    }
                  })
                }
                if (child.Property.Title[0].Text.indexOf("张") > -1 || child.Property.Title[0].Text === "其他(床)"){
                  if (showStr === "无"){
                    child.IsShow = false;
                  }else{
                    child.IsShow = true;
                  }
                }
              })
            }else{
              let otherKey = null;
              children.forEach(child => {
                if (child.Property.Title[0].Text === type){
                  if (child.Config !== null){
                    let options = child.Config.Selector.Options;
                    options.forEach(option => {
                      if (option.Value[0].Text === "其他"){
                        otherKey = option.Key
                      }
                    })
                  }
                }
                if (type === "家电" || type === "卫生间" || type === "厨房"){
                  if (child.Property.Title[0].Text.indexOf(type) > -1 && child.Property.Title[0].Text !== type){
                    if (val.indexOf(otherKey) > -1){
                      child.IsShow = true;
                      child.Property.Require = 1;
                    }else{
                      child.IsShow = false;
                      child.Property.Require = 0;
                    }
                  }
                }
              })
            }
          }
        })
      }else {
        this.tableoperation(val, type, datas, this);
      }
    },
    getEmployeeRelation: async function() {
      await getRelation(this.logInfo.EmpNo).then( response => {
        this.relationList =  response.Body[0].Nodes;
      });
    },
    getSelectorVal(val, name) {
    },
    getTextVal() {},
    getTemplate: async function () {
      var that = this;
      that.listLoading = true;
      await that.getEmployeeRelation();
      const departName = that.logInfo.fullName;
      const jobLevel = that.logInfo.JobLevel;
      const empName = that.logInfo.EmpName;
      const positionName = that.logInfo.PositionName;
      if(departName.indexOf("营业部/住宅部") === -1 || jobLevel < 6){
        this.Message({
          message: '没有申请权限(只有住宅部且职级为6级及以上可申请)',
          type: 'error',
          duration: 3000
        });
        this.isDisabled=true;
      }
      getTemplateInfo(this.templateId).then((response) => {
        var controls = response.Body;
        var that = this;
        controls.TemplateContent.Controls.forEach(async (item) => {
          if (item.Property.Title[0].Text === "申请人/职位") {
            item.Value = `${empName}/${positionName}`;
            item.Disable = true;
          }
          if (item.Property.Title[0].Text === "配套设施"){
            let children = item.Config.Table.Children;
            children.forEach(child => {
              if (child.Property.Title[0].Text.indexOf("其他(") > -1){
                child.Property.Require = 0;
                child.IsShow = false;
              }
              if (child.Property.Title[0].Text.indexOf("张") > -1){
                child.Property.Require = 0;
                child.IsShow = false;
              }
            })
          }
          if (item.Property.Title[0].Text === "基本信息"){
            let children = item.Config.Table.Children;
            children.forEach(child => {
              if (child.Property.Title[0].Text.indexOf("楼层(层)") > -1){
                child.retain = 0;
              }
            })
          }
          if (item.Property.Title[0].Text === "计划入住人数"){
            item.retain = 0;
          }
          if (item.Property.Title[0].Text === "大战区名称"){
            if(departName.indexOf("大战区") > -1){
              let paths = departName.split("/");
              paths.forEach(path => {
                if (path.indexOf("大战区") > -1){
                  item.Value = path;
                  item.Disable = true;
                }
              })
            }else{
              item.Value = "无"
            }
          }
          if (item.Property.Title[0].Text === "抄送控件"){
            item.Values = [];
            item.IsShow = false;
            getDepartmentRelationByName(departName,false).then(res => {
              let nodes = res.Body[0].Nodes;
              nodes.forEach(node => {
                let items = node.Items;
                if (items !== null){
                  items.forEach(nItem => {
                    if (nItem.PositionName.indexOf("行政主任") > -1){
                      item.Values.push([nItem.EmpNo,nItem.EmpName])
                    }
                  })
                }
              })
            })
          }
          if (item.Property.Title[0].Text === "逐级审批使用"){
            item.Values = await that.getRelationList(that.relationList,8);
            if (item.Values == null || item.Values.length < 1) {
              item.Values.push(this.$store.state.defaultMember);
            }
            item.IsShow = false;
          }
        });
        this.templateData = this.assignControl(controls, that.logInfo);
        this.listLoading = false;
      });
    },
    submit: async function () {
      //数据校验
      if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
        return;
      }
      this.templateData.TemplateContent.Controls.forEach(item => {
        if (item.Property.Title[0].Text === "配套设施"){
          let children = item.Config.Table.Children;
          children.forEach(child => {
            if (child.Property.Title[0].Text.indexOf("其他(") > -1){
              child.Property.Require = 0;
              child.IsShow = false;
            }
          })
        }
      })
      this.isDisabled=true;
      var SummaryList = [];
      var info={SummaryInfo:[]}
      info.SummaryInfo=[];

      var info={SummaryInfo:[]}
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请人："+" "+ this.logInfo.EmpName ,"Lang":"zh_CN"});
      SummaryList.push(info);
      var info={SummaryInfo:[]}
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请部门："+" "+ this.logInfo.DeptName ,"Lang":"zh_CN"});
      SummaryList.push(info);
      var info={SummaryInfo:[]}
      var data = new Date();
      var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var dateTime = data.getFullYear() + "-" + month + "-" + date;
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请时间："+" "+ dateTime ,"Lang":"zh_CN"});
      SummaryList.push(info);
      this.templateData.SummaryList = SummaryList
      //提交
      submitProcess(
          this.templateId,
          this.logInfo.EmpNo,
          this.spNo,
          this.templateData
      )
          .then((response) => {
            this.Message({
              message: "申请成功",
              type: "success",
              duration: 3 * 1000,
            });
            setTimeout(() => {
              this.$router.push("/index");
            }, 3000);
          })
          .catch(err => {
            this.isDisabled=false;
          })
          .finally(() => {
            isSubmit = false;
            this.listLoading = false;
          });
    },
  },
};
</script>

<style scoped>

</style>